class RPPError extends Error {
  constructor(message, statusCode) {
    super(message);
    Object.defineProperty(this, "statusCode", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.statusCode = statusCode;
  }
  toString() {
    return this.message;
  }
}
export default RPPError;